<div class="page">
  <div class="container-fluid container-site pt-3">
    <div class="row">
      <div class="col">
        <h1 class="h2 text-uppercase">Liber</h1>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <img src="/img/about/banner.webp" class="img-fluid" alt="Liber" />
      </div>
    </div>

    <div class="row pt-4">
      <div class="col-12 col-md-6">
        <img
          class="img-fluid"
          src="/img/rbs_solo.webp"
          width="140"
          alt="Centro Ricardo B. Salinas Pliego"
        />

        <p class="font-monospace">
          <span class="text-uppercase">{{ president.name }}</span
          ><br /><span>{{ president.role }}</span>
        </p>

        <hr />

        <h2 class="text-uppercase mb-3 h4">Equipo</h2>

        <img
          src="/img/logo-arte.webp"
          alt="Arte y Cultura"
          class="img-fluid mb-4"
          width="180"
        />

        @for (member of arteYCulturaTeam; track member.name) {
          <p class="font-monospace">
            <span class="text-uppercase">{{ member.name }}</span>

            <br />

            <span>{{ member.role }}</span>
          </p>
        }

        <hr />

        <div>
          <img
            src="/img/logov2.webp"
            alt="Liber"
            height="30"
            class="mb-3"
          />
        </div>

        @for (member of liberEditorialTeam; track member.name) {
          <p class="font-monospace">
            <span class="text-uppercase">
              {{ member.name }}
            </span>

            <br />

            <span>{{ member.role }}</span>
          </p>
        }
      </div>

      <div class="col-12 col-md-6">
        <p class="h3 mb-4">
          Revista digital de Arte &amp; Cultura del Centro Ricardo B. Salinas
          Pliego
        </p>

        <div [innerHTML]="bodyHtml"></div>
      </div>
    </div>
  </div>
</div>
